// extracted by mini-css-extract-plugin
export default {"active":"RequestTable_active__DWhWF","inactive":"RequestTable_inactive__TalXQ","revoked":"RequestTable_revoked__yLIry"};